import { __awaiter, __generator } from "tslib";
import { DocumentStatus } from '@tencent/ark-model';
import { DocumentStatusStorage } from '@tencent/ark-storage';
import { LoggerProxy } from '../logger/logger-proxy';
var AbstractOfflineDataCommitter = /** @class */ (function () {
    function AbstractOfflineDataCommitter() {
    }
    Object.defineProperty(AbstractOfflineDataCommitter.prototype, "commitOfflineData", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (offlineData, param, storageManager, newDocumentParam) {
            return __awaiter(this, void 0, void 0, function () {
                var resolvedConflictOfflineData, sortedOfflineData, composedOfflineData, commitResponse;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            LoggerProxy.info(AbstractOfflineDataCommitter.tag, '开始提交离线数据, param = ', param);
                            LoggerProxy.info(AbstractOfflineDataCommitter.tag, '开始提交离线数据, offlineData = ', offlineData);
                            // 没有未提交数据，直接返回
                            if (offlineData.length === 0)
                                return [2 /*return*/, undefined];
                            // 1. 批量提交前预处理，如果有问题则抛异常终止
                            return [4 /*yield*/, this.checkIfOfflineDataCool(offlineData, param, storageManager)];
                        case 1:
                            // 1. 批量提交前预处理，如果有问题则抛异常终止
                            _a.sent();
                            return [4 /*yield*/, this.handleConflictOfflineData(offlineData, param)];
                        case 2:
                            resolvedConflictOfflineData = _a.sent();
                            sortedOfflineData = this.sortOfflineData(resolvedConflictOfflineData, param);
                            composedOfflineData = this.composeOfflineData(sortedOfflineData, newDocumentParam);
                            return [4 /*yield*/, this.postOfflineData(composedOfflineData, param)];
                        case 3:
                            commitResponse = _a.sent();
                            // 6. 处理提交结果，如果有问题则抛异常终止
                            return [4 /*yield*/, this.checkIfCommitResponseCool(commitResponse, param, storageManager)];
                        case 4:
                            // 6. 处理提交结果，如果有问题则抛异常终止
                            _a.sent();
                            return [2 /*return*/, commitResponse];
                    }
                });
            });
        }
    });
    /**
     * 提交离线数据异常时，更新文档状态
     * @param param
     * @param storageManager
     */
    Object.defineProperty(AbstractOfflineDataCommitter.prototype, "updateDocumentStatus", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (param, storageManager) {
            return __awaiter(this, void 0, void 0, function () {
                var globalPadId, secretId, config, documentStatusCollection, documentStatusStorage, now, documentStatus;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            LoggerProxy.info(AbstractOfflineDataCommitter.tag, '更新文档的同步状态信息, param = ', param);
                            globalPadId = param.globalPadId, secretId = param.secretId, config = param.config;
                            documentStatusCollection = storageManager.storage.collection(DocumentStatus);
                            documentStatusStorage = new DocumentStatusStorage(documentStatusCollection);
                            now = Date.now();
                            documentStatus = new DocumentStatus();
                            documentStatus.uid = config.user.uid;
                            documentStatus.secretId = secretId;
                            documentStatus.globalPadId = globalPadId;
                            documentStatus.lastSyncTimestamp = now;
                            documentStatus.lastErrorTimestamp = now;
                            return [4 /*yield*/, documentStatusStorage.upsertStatus(documentStatus)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(AbstractOfflineDataCommitter, "tag", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'AbstractOfflineDataCommitter'
    });
    return AbstractOfflineDataCommitter;
}());
export { AbstractOfflineDataCommitter };
